import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import {useNavigate } from 'react-router-dom'
import TopBar from "../../components/TopBarV2";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Icon from '@mui/material/Icon';
import {useIntl} from 'react-intl'
import Stepper from "../../components/stepper";
import IconButton from "@mui/material/IconButton/IconButton";
import Tooltip from "@mui/material/Tooltip/Tooltip";


const tiers = [


    {
        title: 'Creator',
        id: 'creator',
        text:'You are creating projects and looking for investors/artist to work with you'
    },
    {
        title: 'Investor',
        id: 'investor', 
        text: "You are an Investor looking for projects to invest in"
    },
    {
        title: 'Artist',
        id: 'artist',
        text:"You have a skill and want to work with creators for their projects"
    },
];

function WhoAreYou() {
    const [selected, setSelected] = React.useState();
    const navigator = useNavigate()
    const {messages} = useIntl()

    console.log(messages)
    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            {/* Hero unit */}
            {/*<TopBar/>*/}
            <Stepper stepNumber={1}/>
            <Container  maxWidth="lg" component="main" sx={{ }}>
                <Typography variant="h4" align="left" color="text.primary" component="p">
                    Create an <font color="#204488">account</font> in 4 steps
                    {/*{messages?.joinNow?.who_are_you?.pageTitle}*/}
                </Typography>

                <Typography variant="h5" align="left" color="text.primary" sx={{marginTop: '5px'}} component="p">
                    {messages?.joinNow?.who_are_you?.title}

                </Typography>
            </Container>
            <Container disableGutters maxWidth="lg" component="main" sx={{ pt: 4, pb: 5 }}>

            </Container>
            {/* End hero unit */}
            <Container maxWidth="lg" component="main" > 
                <Grid container spacing={5} alignItems="flex-end">
                    {tiers.map((tier, i) => (
                        // Enterprise card is full width at sm breakpoint
                        <Grid
                            item
                            key={tier.title}
                            xs={12}
                            sm={tier.title === 'Enterprise' ? 12 : 6}
                            md={4}
                            
                                                 >
                            <Paper elevation={4} >

                                <Box onClick={() => setSelected(tier.id)}
                                     sx={{
                                         display: 'flex',
                                         justifyContent: 'center',
                                         alignItems: 'center',
                                         flexDirection:'column',
                                         mb: 2,
                                         pb:4,
                                         height: 250, backgroundColor: `${tier.id !== selected ? '#ffffff': '#204488' }`, borderRadius: '10px'
                                     }}
                                >
                                    <div style={{width: '90%', textAlign:'right', color: `${tier.id !== selected ? '#204488' : '#ffffff' }`, position:'relative', top: -15}}>
                                        <Tooltip  componentsProps={{
                        tooltip: {
                            
                          sx: {
                            color: '#204488',
                            maxWidth: "223px",
                            paddingTop: 2 ,
                            height: 122,
                            fontSize:17,
                           textAlign: 'center',
                                               
                                       
                            bgcolor: '#E3E8F0',
                            '& .MuiTooltip-arrow': {
                              color: '#E3E8F0',
                            },
                          },
                        },
                      }} title={tier.text } arrow sx={{width:"30px", }}  >
                                                <IconButton>
                                                    <HelpOutlineIcon style={{fontSize:30 ,color: tier.id !== selected ? '#204488': '#fff' }}/>
                                                </IconButton>
                                        </Tooltip>


                                    </div>
                                    <img src={tier.id !== selected ? `/assets/${tier.title}-grey.png`: `/assets/${tier.title}-grey.png`} height={70} style={{marginBottom: '20px'}} alt=""/>
                                    <Typography  variant="h4"  component="p" color={tier.id !== selected ? '#204488': '#fff'} >
                                        {messages?.joinNow?.who_are_you?.option[i]}
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Container disableGutters maxWidth="lg"  component="main" sx={{ pt: 8, pb: 6 }}>

                <Stack spacing={2} direction="row" sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5}} disabled={!selected} onClick={() => {navigator('/auth/join-us', {state:{selected}})}}> {messages?.joinNow?.who_are_you?.nextButton}</Button>
                </Stack>
            </Container>
        </React.Fragment>
    );
}

export default WhoAreYou;